import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { PageHeader, DataTable, Pill } from "../components/Table";

const SEV = { critical: "#FF3B30", high: "#FF9500", medium: "#5AC8FA", low: "#8E8E93" };

export default function Alerts() {
  const [alerts, setAlerts] = useState([]);
  const [sev, setSev] = useState("");

  const load = () => api.get(`/alerts${sev ? "?severity=" + sev : ""}`).then((r) => setAlerts(r.data.alerts));
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, [sev]);

  const ack = async (id) => { await api.post(`/alerts/${id}/acknowledge`); toast.success("Acknowledged"); load(); };

  const columns = [
    { key: "type", header: "Type", render: (r) => <span className="font-semibold">{r.type}</span> },
    { key: "severity", header: "Severity", render: (r) => <Pill color={SEV[r.severity]}>{r.severity}</Pill> },
    { key: "vehicle_number", header: "Vehicle", render: (r) => <span className="font-mono">{r.vehicle_number}</span> },
    { key: "message", header: "Message", render: (r) => <span className="text-muted-foreground">{r.message}</span> },
    { key: "timestamp", header: "Time", render: (r) => <span className="text-xs text-muted-foreground">{new Date(r.timestamp).toLocaleString()}</span> },
    { key: "ack", header: "", render: (r) => r.acknowledged
      ? <span className="text-xs text-[#34C759]">ACK</span>
      : <button data-testid={`ack-${r.id}`} onClick={(e) => { e.stopPropagation(); ack(r.id); }} className="text-xs font-semibold px-2 py-1 border border-border rounded-sm hover:border-primary">Ack</button> },
  ];

  return (
    <div className="p-5 space-y-4">
      <PageHeader title="Alerts Engine" subtitle="Real-time rule-based fleet alerts"
        actions={
          <div className="flex gap-1">
            {["", "critical", "high", "medium"].map((s) => (
              <button key={s} onClick={() => setSev(s)}
                className={`text-xs font-bold uppercase px-3 py-1.5 rounded-sm border ${sev === s ? "border-primary bg-primary/15" : "border-border text-muted-foreground"}`}>
                {s || "All"}
              </button>
            ))}
          </div>
        } />
      <DataTable testid="alerts-table" columns={columns} rows={alerts} />
    </div>
  );
}
